
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93mKhrQ6y8BgBFOXRa2iZG0xMgzNUkkOYvDnBX50FZsJIMeta } from "/usr/src/app/pages/[...slug].vue?macro=true";
import { default as component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  }
]